import { ChakraProps, chakra } from '@aloft/toolkit-sui/chakra';
import { Cell as ReactTableCell, flexRender } from '@tanstack/react-table';

import { sharedCellStyles } from '../constants.js';
import { getCellStyles } from '../getCellStyles.js';
import { getCellWidthStyles } from '../getCellWidthStyles.js';
import { getPinnedCellStyles } from '../getPinnedCellStyles.js';
import { usePinnedColumnStyles } from '../usePinnedColumnStyles.js';

type Props<T> = {
  cell: ReactTableCell<T, unknown>;
  shouldPinFirstRow: boolean | number;
  rowIndex: number;
  pinnedColumnStyles: ReturnType<typeof usePinnedColumnStyles>;
};

export function Cell<T>({ cell, shouldPinFirstRow, rowIndex, pinnedColumnStyles }: Props<T>) {
  const styles: ChakraProps = {
    ...sharedCellStyles,
    ...pinnedColumnStyles.getStyles(cell.column),
    ...getCellWidthStyles(cell.column.getSize()),
    ...getCellStyles(),
    ...getPinnedCellStyles(shouldPinFirstRow, rowIndex),
  };
  const content = flexRender(cell.column.columnDef.cell, cell.getContext());

  return (
    <chakra.td key={cell.id} {...styles}>
      {content}
    </chakra.td>
  );
}
